/**
 * Maps new classes API field names to legacy API field names for include parameters
 */
export const INCLUDE_FIELD_MAP = {
  streaming_host_url: 'join_url',
  descriptive_time: 'time',
  language_code: 'language_id',
  duration_minutes: 'duration_in_minutes',
  status: 'class_status',
  email: 'learner_email',
  number_of_participants: 'reservation_count',
  lesson_title: 'lesson',
  feedback_submitted: 'has_submitted_feedback',
  learner_found_class_helpful: 'feedback_score',
  max_participants: 'max_reservation_count',
  canceled_at: 'learner_cancel_ts',
  created_at_descriptive_datetime: 'class_booked_timestamp',
  webackend_id: 'id',
  class_type_label: 'class_type',
};

/**
 * Helper function to create both ascending and descending mappings for a field
 * @param {string} newField - Field name in new API format
 * @param {string} legacyField - Field name in legacy API format
 * @returns {Object} Object containing both ascending and descending mappings
 */
const createOrderingMappings = (newField, legacyField) => ({
  [newField]: legacyField,
  [`-${newField}`]: `-${legacyField}`,
});

/**
 * Base mapping of new classes API field names to legacy API field names
 */
const ORDERING_FIELD_MAP = {
  teacher_name: 'teacher',
  scheduled_at: 'date',
  language_code: 'teachingLanguage',
  duration_minutes: 'duration',
  class_type: 'classType',
  status: 'classStatus',
  learner_first_name: 'firstName',
  learner_last_name: 'lastName',
  organization_id: 'organization',
  number_of_participants: 'reservationCount',
  group_attendance: 'groupAttendance',
  lesson_title: 'lesson',
  feedback_submitted: 'hasSubmittedFeedback',
  learner_found_class_helpful: 'feedbackScore',
  max_participants: 'maxReservationCount',
  canceled_at: 'canceledAt',
  created_at: 'classBookedTs',
  webackend_id: 'id',
};

/**
 * Maps new API field names to legacy API field names for ordering parameters,
 * including both ascending and descending versions
 */
export const ORDERING_MAP = Object.entries(ORDERING_FIELD_MAP).reduce((acc, [newField, legacyField]) => {
  return {
    ...acc,
    ...createOrderingMappings(newField, legacyField),
  };
}, {});
